import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { ObjectManagement } from '../../models/object-management';
import {
  MatBottomSheetRef,
  MAT_BOTTOM_SHEET_DATA,
} from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';

export interface PatternDialogData {
  mode: 'success' | 'warning';
  functionality: boolean;
  title: string;
  description?: string;
  objectData?: ObjectManagement;
  returnFunctionality: boolean;
}

@Component({
  selector: 'app-pattern-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pattern-dialog.component.html',
  styleUrl: './pattern-dialog.component.scss',
})
export class PatternDialogComponent {
  public readonly data: PatternDialogData;

  constructor(
    /* Диалог – Desktop */
    @Optional()
    private dialogRef: MatDialogRef<PatternDialogComponent>,
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    dialogData: PatternDialogData | null,

    /* Bottom-sheet – Mobile */
    @Optional()
    private sheetRef: MatBottomSheetRef<PatternDialogComponent>,
    @Optional()
    @Inject(MAT_BOTTOM_SHEET_DATA)
    sheetData: PatternDialogData | null,
    private router: Router
  ) {
    this.data = dialogData ?? sheetData!;
  }

  close(): void {
    this.dialogRef?.close();
    this.sheetRef?.dismiss();
  }

  apply(): void {
    this.dialogRef?.close(true);
    this.sheetRef?.dismiss(true);
  }

  returnToMainPage(): void {
    this.router.navigate(['']);
  }
}
